import { useContext } from "react";
import { AuthContext } from "./user.context";
import { LoadingProvider } from "./UI.context";
import { AuctionsProvider } from "./auction.context";
import { NowProvider } from "./now.context";
import { FavoritesProvider } from "./favorites.context";

const OperationalTree = ({ children }) => (
  <LoadingProvider>
    <NowProvider>
      <AuctionsProvider>
        <FavoritesProvider>{children}</FavoritesProvider>
      </AuctionsProvider>
    </NowProvider>
  </LoadingProvider>
);

/**
 * WEB-005: una nueva key desmonta el árbol operativo completo. React ejecuta
 * los cleanups de effects/listeners y descarta cachés, formularios y estados
 * antes de montar la unidad seleccionada.
 */
export const OperationalProviders = ({ children }) => {
  const { operationalContextKey } = useContext(AuthContext);
  return (
    <OperationalTree key={operationalContextKey}>{children}</OperationalTree>
  );
};
